module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/shop_chapelsuns_03-c93b125cc12719193dd6f0ca1a376647.png";